module.exports = __webpack_public_path__ + "static/castrovalley-4f57d1965324fe78cb390b34ae5ea508.jpg";